import React, { useContext } from 'react';
import styles from './styles.css';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import Heading from '../../components/Typography/Heading/Heading';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const RolloverTypeScreen = () => {
  const { back, flowProps } = useContext(FlowContext);
  const { title, options: Options } = flowProps;

  return (
    <div>
      <Heading text={title} />
      <Options />
      <MFBeaconButton
        variant="secondary"
        size="normal"
        id="rolloverTypeBack"
        className="beacon-button-margin-override"
        data-name={generateGeneralTestID('RolloverOptions', 'BackButton')}
        onClick={back()}
        label="Back"
      />
      <PhoneNumber />
      <style jsx>{styles}</style>
    </div>
  );
};

export default RolloverTypeScreen;
